import React from 'react';
import { theme } from 'antd';
import { useProject } from '../hooks';
import { getPhaseStatusColor, getPhaseStatusText } from '../utils/phaseFactory';

const { useToken } = theme;

export const ProjectProgressPopover: React.FC = () => {
  const { token } = useToken();
  const { phases } = useProject();

  if (!phases.length) return null;

  return (
    <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '8px' }}>
      {phases.map((phase, index) => (
        <div key={phase.id} style={{ display: 'flex', marginBottom: '16px', position: 'relative' }}>
          {/* Line connector */}
          {index < phases.length - 1 && (
            <div
              style={{
                position: 'absolute',
                left: '12px',
                top: '24px',
                bottom: '-16px',
                width: '2px',
                backgroundColor: token.colorSplit,
              }}
            />
          )}

          <div style={{ marginRight: '16px', zIndex: 1 }}>
            <div
              style={{
                width: '26px',
                height: '26px',
                borderRadius: '50%',
                backgroundColor: getPhaseStatusColor(phase, token),
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
              }}>
              {index + 1}
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontWeight: 'bold',
                color: phase.locked ? token.colorTextDisabled : token.colorText,
              }}>
              {phase.name}
            </div>
            <div style={{ fontSize: '12px', color: token.colorTextSecondary }}>
              {getPhaseStatusText(phase)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
